/**
 * Minimal service worker registration.
 * Only registers the worker so the app is installable; no caching logic.
 */
export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('[SW Registration] Error during registration:', error);
    });
  });
}

/**
 * Unregister the service worker.
 */
export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => {
      console.error('[SW Registration] Error during unregistration:', error);
    });
}
